import script from "./PedidoVendaItensExcel.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoVendaItensExcel.vue?vue&type=script&setup=true&lang=js"

import "./PedidoVendaItensExcel.vue?vue&type=style&index=0&id=0db1c3e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db1c3e9"]])

export default __exports__